import { render } from "./AddProductCategoryMetaData.vue?vue&type=template&id=c5bc2b66"
import script from "../js/add-product-category-meta-data.js?vue&type=script&lang=js"
export * from "../js/add-product-category-meta-data.js?vue&type=script&lang=js"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/disposhop_jars/dispo_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__